const ZIPCODE_RANGES = [
    { province: "SP", from: 1e6, to: 19999999 },
    { province: "RJ", from: 2e7, to: 28999999 },
    { province: "ES", from: 29e6, to: 29999999 },
    { province: "MG", from: 3e7, to: 39999999 },
    { province: "BA", from: 4e7, to: 48999999 },
    { province: "SE", from: 49e6, to: 49999999 },
    { province: "PE", from: 5e7, to: 56999999 },
    { province: "AL", from: 57e6, to: 57999999 },
    { province: "PB", from: 58e6, to: 58999999 },
    { province: "RN", from: 59e6, to: 59999999 },
    { province: "CE", from: 6e7, to: 63999999 },
    { province: "PI", from: 64e6, to: 64999999 },
    { province: "MA", from: 65e6, to: 65999999 },
    { province: "PA", from: 66e6, to: 68899999 },
    { province: "AP", from: 689e5, to: 68999999 },
    { province: "AM", from: 69e6, to: 69299999 },
    { province: "RR", from: 693e5, to: 69399999 },
    { province: "AM", from: 694e5, to: 69899999 },
    { province: "AC", from: 699e5, to: 69999999 },
    { province: "DF", from: 7e7, to: 72799999 },
    { province: "GO", from: 728e5, to: 72999999 },
    { province: "DF", from: 73e6, to: 73699999 },
    { province: "GO", from: 737e5, to: 76799999 },
    { province: "RO", from: 768e5, to: 76999999 },
    { province: "TO", from: 77e6, to: 77999999 },
    { province: "MT", from: 78e6, to: 78899999 },
    { province: "MS", from: 79e6, to: 79999999 },
    { province: "PR", from: 8e7, to: 87999999 },
    { province: "SC", from: 88e6, to: 89999999 },
    { province: "RS", from: 9e7, to: 99999999 },
  ],
  getZipcodeProvince = (e) => {
    let t = "";
    try {
      const a = parseInt(e.replace("-", ""));
      for (const e in ZIPCODE_RANGES) {
        const i = ZIPCODE_RANGES[e];
        a >= i.from && a <= i.to && (t = i.province);
      }
    } catch (e) {
      console.log(e);
    }
    return t;
  },
  DAY_OF_THE_WEEK = [
    "domingo",
    "segunda",
    "terça",
    "quarta",
    "quinta",
    "sexta",
    "sábado",
  ],
  convertDeliveryDate = (e) => {
    let t = "";
    if (e && e.length > 0)
      try {
        const a = new Date(e),
          i = new Date(a.getTime() + 864e5),
          r = i.getDate(),
          n = i.getMonth() + 1;
        t = `Chega ${DAY_OF_THE_WEEK[i.getDay()]} ${r > 9 ? r : `0${r}`}/${n > 9 ? n : `0${n}`}`;
      } catch (e) {}
    return t;
  },
  convertDeliveryDays = (e, t, a) => {
    try {
      const i = new Date(t);
      return 0 === new Date(i.getTime() + 864e5).getDay()
        ? ((e += 1), `${a.replace("[days]", e)}`)
        : `${a.replace("[days]", e)}`;
    } catch (e) {
      return (console.error("Erro ao calcular a quantidade de dias:", e), !1);
    }
  };
class DrawerShippingCalculator extends HTMLElement {
  constructor() {
    (super(),
      (this.zipcodeInput = this.querySelector("#ZipcodeInput")),
      (this.calculateBtn = this.querySelector("#CalculateBtn")),
      (this.rates = this.querySelector(".shipping-calculator__rates")),
      (this.ratesWrapper = this.querySelector(
        ".shipping-calculator__rates-wrapper",
      )),
      (this.message = this.getAttribute("data-message")),
      (this.locale = this.getAttribute("data-locale")),
      (this.messageWarning = this.querySelector(
        ".shipping-calculator__rates-error-message",
      )),
      (this.isCalculating = !1),
      (this.countryMap = { BR: "Brazil", CO: "Colombia", MX: "Mexico" }),
      this.init());
  }
  init() {
    ("pt-BR" == this.locale &&
      VMasker(this.zipcodeInput).maskPattern("99999-999"),
      this.calculateBtn.addEventListener(
        "click",
        this.handleCalculate.bind(this),
      ),
      this.calculateWithCurrentZipcode(),
      document.addEventListener(
        "ajaxProduct:added",
        this.calculateWithCurrentZipcode.bind(this),
      ),
      document.addEventListener(
        "cart:updated",
        this.calculateWithCurrentZipcode.bind(this),
      ));
  }
  calculateWithCurrentZipcode() {
    const e = sessionStorage.getItem("ollie:shipping:currentZipcode");
    e && ((this.zipcodeInput.value = e), this.calculateShippingRates(e, !1));
  }
  async handleCalculate(e) {
    (e.preventDefault(), this.toggleLoading(!0));
    const t = this.zipcodeInput.value;
    (await this.calculateShippingRates(t, !0), this.toggleLoading(!1));
  }
  toggleLoading(e) {
    e
      ? this.calculateBtn.classList.add("btn--loading")
      : this.calculateBtn.classList.remove("btn--loading");
  }
  getCountryName() {
    const e = this.detectCountryBasedOnLocale();
    return this.countryMap[e] || "Brazil";
  }
  detectCountryBasedOnLocale() {
    if ("es" === this.locale) {
      const e = window.location.href;
      if (e.includes("mx")) return "MX";
      if (e.includes("co")) return "CO";
    }
    return "BR";
  }
  getColombianProvince(e) {
    const t = parseInt(e, 10);
    return t >= 11e4 && t <= 119999
      ? "Bogotá"
      : t >= 13e4 && t <= 139999
        ? "Antioquia"
        : t >= 22e4 && t <= 229999
          ? "Atlántico"
          : t >= 76e4 && t <= 769999
            ? "Valle del Cauca"
            : t >= 5e5 && t <= 509999
              ? "Cundinamarca"
              : t >= 1e5 && t <= 199999
                ? "Santander"
                : t >= 15e4 && t <= 159999
                  ? "Boyacá"
                  : t >= 2e5 && t <= 209999
                    ? "Cesar"
                    : t >= 4e5 && t <= 409999
                      ? "Huila"
                      : t >= 5e5 && t <= 509999
                        ? "Magdalena"
                        : t >= 6e5 && t <= 609999
                          ? "Nariño"
                          : t >= 7e5 && t <= 709999
                            ? "Risaralda"
                            : t >= 8e5 && t <= 809999
                              ? "Cauca"
                              : t >= 9e5 && t <= 909999
                                ? "Quindío"
                                : t >= 1e6 && t <= 1099999
                                  ? "Tolima"
                                  : t >= 11e5 && t <= 1199999
                                    ? "La Guajira"
                                    : t >= 12e5 && t <= 1299999
                                      ? "Vaupés"
                                      : t >= 13e5 && t <= 1399999
                                        ? "Chocó"
                                        : t >= 14e5 && t <= 1499999
                                          ? "Arauca"
                                          : t >= 15e5 && t <= 1599999
                                            ? "Vichada"
                                            : t >= 16e5 && t <= 1699999
                                              ? "Putumayo"
                                              : t >= 17e5 && t <= 1799999
                                                ? "Caquetá"
                                                : t >= 18e5 && t <= 1899999
                                                  ? "San Andrés y Providencia"
                                                  : null;
  }
  getMexicanProvince(e) {
    const t = parseInt(e, 10);
    return t >= 1e3 && t <= 16999
      ? "Ciudad de México"
      : t >= 2e4 && t <= 20999
        ? "Aguascalientes"
        : t >= 21e3 && t <= 22999
          ? "Baja California"
          : t >= 23e3 && t <= 23999
            ? "Baja California Sur"
            : t >= 24e3 && t <= 24999
              ? "Campeche"
              : t >= 25e3 && t <= 28999
                ? "Coahuila"
                : t >= 29e3 && t <= 29999
                  ? "Chiapas"
                  : t >= 3e4 && t <= 33999
                    ? "Chihuahua"
                    : t >= 34e3 && t <= 34999
                      ? "Durango"
                      : t >= 35e3 && t <= 35999
                        ? "Guanajuato"
                        : t >= 36e3 && t <= 37999
                          ? "Guerrero"
                          : t >= 38e3 && t <= 38999
                            ? "Hidalgo"
                            : t >= 42e3 && t <= 43999
                              ? "Jalisco"
                              : t >= 44e3 && t <= 49999
                                ? "Estado de México"
                                : t >= 5e4 && t <= 53999
                                  ? "Michoacán"
                                  : t >= 54e3 && t <= 55999
                                    ? "Morelos"
                                    : t >= 56e3 && t <= 57999
                                      ? "Nayarit"
                                      : t >= 58e3 && t <= 59999
                                        ? "Nuevo León"
                                        : t >= 6e4 && t <= 63999
                                          ? "Oaxaca"
                                          : t >= 64e3 && t <= 65999
                                            ? "Puebla"
                                            : t >= 66e3 && t <= 66999
                                              ? "Querétaro"
                                              : t >= 67e3 && t <= 67999
                                                ? "Quintana Roo"
                                                : t >= 68e3 && t <= 68999
                                                  ? "San Luis Potosí"
                                                  : t >= 69e3 && t <= 69999
                                                    ? "Sinaloa"
                                                    : t >= 7e4 && t <= 73999
                                                      ? "Sonora"
                                                      : t >= 74e3 && t <= 75999
                                                        ? "Tabasco"
                                                        : t >= 76e3 &&
                                                            t <= 79999
                                                          ? "Tamaulipas"
                                                          : t >= 8e4 &&
                                                              t <= 83999
                                                            ? "Tlaxcala"
                                                            : t >= 84e3 &&
                                                                t <= 86999
                                                              ? "Veracruz"
                                                              : t >= 87e3 &&
                                                                  t <= 89999
                                                                ? "Yucatán"
                                                                : t >= 9e4 &&
                                                                    t <= 93999
                                                                  ? "Zacatecas"
                                                                  : null;
  }
  async calculateShippingRates(e, t) {
    if (this.isCalculating) return;
    this.isCalculating = !0;
    const a = this.getCountryName();
    let i = { zip: e, country: a };
    if ("Brazil" === a && 9 === e.length) {
      const t = getZipcodeProvince(e);
      i.province = t;
    }
    if ("Mexico" === a && 5 === e.length) {
      const t = this.getMexicanProvince(e);
      t && (i.province = t);
    }
    if ("Colombia" === a && 6 === e.length) {
      const t = this.getColombianProvince(e);
      t && (i.province = t);
    }
    const r = Object.keys(i)
      .map((e) => `shipping_address[${e}]=${i[e]}`)
      .join("&");
    (t &&
      (this.rates.classList.remove("show"), (this.ratesWrapper.innerHTML = "")),
      await this.prepareShippingRates(e, r),
      (this.isCalculating = !1));
  }
  handleMessageWarning(e) {
    (console.log("handleMessageWarning", e),
      this.messageWarning &&
        (e
          ? (this.messageWarning.classList.remove("hidden"),
            (this.ratesWrapper.innerHTML = ""),
            this.rates.classList.add("show"))
          : this.messageWarning.classList.add("hidden")));
  }
  async prepareShippingRates(e, t) {
    await fetch(`/cart/prepare_shipping_rates.json?${t}`, { method: "POST" })
      .then(async (e) => e.json())
      .then(async (a) => {
        (await this.getShippingRates(e, t),
          null != a
            ? this.handleMessageWarning(!0)
            : this.handleMessageWarning(!1));
      });
  }
  async getShippingRates(e, t) {
    await fetch(`/cart/async_shipping_rates.json?${t}`, { method: "GET" })
      .then((e) => e.json())
      .then((a) => {
        a && a.shipping_rates
          ? (sessionStorage.setItem("ollie:shipping:currentZipcode", e),
            this.populateShippingRates(a.shipping_rates))
          : setTimeout(() => {
              this.getShippingRates(e, t);
            }, 1e3);
      });
  }
  populateShippingRates(e) {
    this.ratesWrapper.innerHTML = "";
    for (let t = 0; t < e.length; t++) {
      const a = e[t],
        i =
          a.delivery_range && a.delivery_range.length > 1
            ? a.delivery_range[1]
            : "",
        r =
          parseFloat(a.price) > 0
            ? theme.Currency.formatMoney(a.price, theme.settings.moneyFormat)
            : "GRÁTIS",
        n = document.createElement("div");
      (n.classList.add("rate-item"),
        void 0 !== a.delivery_days[0] && a.delivery_days[0] > 0
          ? (n.innerHTML = `<p><strong>${a.name}</strong><br>${convertDeliveryDays(a.delivery_days[0], i, this.message)}</p>\n      <p class="rate-price">${r}</p>`)
          : (n.innerHTML = `<p><strong>${a.name}</strong><br>${convertDeliveryDate(i)}</p>\n        <p class="rate-price">${r}</p>`),
        this.ratesWrapper.append(n));
    }
    ((this.isCalculating = !1), this.rates.classList.add("show"));
  }
}
if (!customElements.get("drawer-shipping-calculator")) {
  customElements.define("drawer-shipping-calculator", DrawerShippingCalculator);
}

class CartShippingEstimator extends HTMLElement {
  constructor() {
    super();
    this.isCalculating = false;
    this.handleInput = this.handleInput.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  connectedCallback() {
    this.input = this.querySelector(".shipping-zip");
    this.button = this.querySelector(".shipping-button");
    this.feedback = this.querySelector(".shipping-feedback");
    this.message = this.getAttribute("data-message") || "Entrega em [days] dias uteis";

    if (!this.input || !this.button || !this.feedback) return;

    this.input.removeEventListener("input", this.handleInput);
    this.button.removeEventListener("click", this.handleClick);
    this.removeEventListener("submit", this.handleSubmit);

    this.input.addEventListener("input", this.handleInput);
    this.button.addEventListener("click", this.handleClick);
    this.addEventListener("submit", this.handleSubmit);

    const storedZip = sessionStorage.getItem("ollie:shipping:currentZipcode");
    if (storedZip && !this.input.value) {
      this.input.value = this.formatZip(storedZip);
    }
  }

  disconnectedCallback() {
    this.input?.removeEventListener("input", this.handleInput);
    this.button?.removeEventListener("click", this.handleClick);
    this.removeEventListener("submit", this.handleSubmit);
  }

  handleInput(event) {
    event.target.value = this.formatZip(event.target.value);
  }

  handleClick(event) {
    event.preventDefault();
    this.calculate();
  }

  handleSubmit(event) {
    event.preventDefault();
    this.calculate();
  }

  formatZip(zip) {
    return zip
      .replace(/\D/g, "")
      .slice(0, 8)
      .replace(/^(\d{5})(\d)/, "$1-$2");
  }

  normalizeZip() {
    return (this.input?.value || "").replace(/\D/g, "").slice(0, 8);
  }

  setFeedback(message, isLoading = false) {
    if (!this.feedback) return;

    this.feedback.innerHTML = message;
    this.feedback.classList.toggle("shipping-loading", isLoading);
  }

  setLoading(isLoading) {
    this.isCalculating = isLoading;
    this.button?.classList.toggle("btn--loading", isLoading);
    this.button?.toggleAttribute("disabled", isLoading);
    this.button?.setAttribute("aria-busy", String(isLoading));
  }

  async calculate() {
    if (this.isCalculating) return;

    const zip = this.normalizeZip();
    if (zip.length !== 8) {
      this.setFeedback("Digite um CEP valido.");
      return;
    }

    if (this.input) this.input.value = this.formatZip(zip);

    this.setLoading(true);
    this.setFeedback("Calculando...", true);

    try {
      const query = this.buildShippingQuery(zip);
      await this.prepareShippingRates(query);
      const rates = await this.getShippingRates(query);

      if (!rates.length) {
        this.setFeedback("Nenhuma opcao disponivel.");
        return;
      }

      sessionStorage.setItem("ollie:shipping:currentZipcode", zip);
      this.renderRates(rates);
    } catch (error) {
      console.error(error);
      this.setFeedback("Erro ao calcular frete.");
    } finally {
      this.setLoading(false);
      this.feedback?.classList.remove("shipping-loading");
    }
  }

  buildShippingQuery(zip) {
    const shippingAddress = {
      zip,
      country: "Brazil",
      province: getZipcodeProvince(zip),
    };

    return Object.entries(shippingAddress)
      .filter(([, value]) => value)
      .map(([key, value]) => `shipping_address[${key}]=${encodeURIComponent(value)}`)
      .join("&");
  }

  async prepareShippingRates(query) {
    const response = await fetch(`/cart/prepare_shipping_rates.json?${query}`, {
      method: "POST",
    });

    if (!response.ok) throw new Error("prepare_shipping_rates failed");
  }

  async getShippingRates(query, attempt = 0) {
    const response = await fetch(`/cart/async_shipping_rates.json?${query}`);
    if (!response.ok) throw new Error("async_shipping_rates failed");

    const data = await response.json();
    if (data?.shipping_rates) return data.shipping_rates;

    if (attempt >= 8) return [];

    await new Promise((resolve) => setTimeout(resolve, 700));
    return this.getShippingRates(query, attempt + 1);
  }

  renderRates(rates) {
    const cheapestRate = rates.reduce((cheapest, rate) => {
      if (!cheapest) return rate;
      return parseFloat(rate.price) < parseFloat(cheapest.price) ? rate : cheapest;
    }, null);

    const ratesToShow = cheapestRate ? [cheapestRate] : rates;

    this.setFeedback(
      ratesToShow
        .map((rate) => {
          const price = this.formatMoney(rate.price);
          const min = rate.delivery_days?.[0];
          const max = rate.delivery_days?.[1];
          const deadline = this.formatDeadline(min, max);

          return `
            <div class="shipping-rate">
              <div>
                <div>${rate.name}</div>
                <small>${deadline}</small>
              </div>
              <strong>${price}</strong>
            </div>
          `;
        })
        .join("")
    );
  }

  formatDeadline(min, max) {
    if (!min && !max) return "";
    if (min === max || !max) return `Entrega em ${min} dias uteis`;
    return `Entrega em ${min} a ${max} dias uteis`;
  }

  formatMoney(value) {
    const numericValue = parseFloat(value || 0);

    if (numericValue <= 0) return "GRATIS";

    return numericValue.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }
}

if (!customElements.get("cart-shipping-estimator")) {
  customElements.define("cart-shipping-estimator", CartShippingEstimator);
}
